const VolunteerCTA = () => {
    return <span>This content is for Ducks Unlimited volunteers only. <a className="btn btn-primary" href="https://www.ducks.org/get-involved">Volunteer for Ducks Unlimited</a></span>
};

export default VolunteerCTA;
